import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestOptions } from '../modal/RequestOptions';
import { environment } from '../../environments/environments';

@Injectable({
  providedIn: 'root',
})
export class IndicadorFilaService {
  constructor(private http: HttpClient) {}
  private apiUrl = environment.API_URL;
  private map = "ss.fila";

  getindicadores(codigo: number, codigoCentralPosto: string, codigoCentralOrgao: string, login: string): Observable<any> {
    const url = this.apiUrl+this.map+'/getFilaIndicador?id='+codigo+'&ccPosto='+codigoCentralPosto+'&ccOrgao='+codigoCentralOrgao+'&login='+login;
    return this.http.get(url);
  }
}
